import React from "react";
import MainTemplate from "../../../components/MainTemplate/MainTemplate";
import CardBackground from "../../../components/MainTemplate/CardBackground";
import IncomeListChild from "./IncomeListChild";

const IncomeList = () => {
  return (
    <MainTemplate>
      <CardBackground>
        <IncomeListChild />
      </CardBackground>
    </MainTemplate>
  );
};

export default IncomeList;
